import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { getAuthUrl } from "@/utils/redirectUtils";

const FinalCTASection = () => {
  return (
    <section className="py-24 px-4 bg-primary text-primary-foreground">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-6">
          Build your first campaign in 60 seconds
        </h2>
        <p className="text-lg mb-10 opacity-90 max-w-2xl mx-auto">
          Seven days free, then from $99/month. Enter your landing page URL, get 5 structured ad groups with negative keyword filters, and launch risk-free.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
          <Button
            size="lg"
            className="text-lg px-8 h-14 bg-background text-foreground hover:bg-background/90 font-semibold"
            onClick={() => window.location.href = getAuthUrl()}
          >
            Start 7-day free trial <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button
            size="lg"
            className="text-lg px-8 h-14 bg-white text-primary hover:bg-white/90 font-semibold"
            onClick={() => window.location.href = "/pricing"}
          >
            See pricing
          </Button>
        </div>

        <p className="text-sm opacity-70">
          7-day free trial · Cancel any time · $49/mo founder pricing for the first 50 customers
        </p>
      </div>
    </section>
  );
};

export default FinalCTASection;
